import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'treeview-node',
  templateUrl: './treeviewnode.component.html',
  styleUrls: ['./treeviewnode.component.scss'],
})
export class TreeViewNodeComponent implements OnInit {
  @Input() node: any;
  @Output() selectedNode: EventEmitter<IItemTreeView>;
  @Output() loadNode: EventEmitter<IItemTreeView>;
  @Output() itemSelected: EventEmitter<IItemTreeView>;

  constructor() { 
    this.selectedNode = new EventEmitter<IItemTreeView>();
    this.loadNode = new EventEmitter<IItemTreeView>();
    this.itemSelected = new EventEmitter<IItemTreeView>();
  }

  ngOnInit() {
  }

  ngOnChanges() {   
    this.updateNodeFromChildren();  
  }

  haveChildren() {
    return this.node.nodes && this.node.nodes.length > 0;
  }

  getExpandedIcon() {
    return this.node.isExpanded ? '-' : '+';
  }

  onSelectedNode(node: IItemTreeView) {
    this.selectedNode.emit(node);
  }

  toggle() {
    this.node.isExpanded = !this.node.isExpanded;
    if (this.node.nodes.length === 0) {
        this.loadNode.emit(this.node);
    }
  }

  onCheck() {
    this.node.isChecked = !this.node.isChecked;
    if (this.node.isChecked) {
      this.node.isPartial = false;
    }
    if (this.node.nodes !== null) {
      this.updateChildren(this.node);
    }
    this.itemSelected.emit(this.node);
  }

  onEmitCheck() {
    this.updateNodeFromChildren();   

  }

  private updateNodeFromChildren() {
    if (this.node.nodes && this.node.nodes.length > 0) {
      this.node.isChecked = this.node.nodes.every(child => child.isChecked);
    }

    this.updateNodeClass();
    this.itemSelected.emit(this.node);
  }

  private updateChildren(node: IItemTreeView) {
    node.nodes.map(child => {
      child.isChecked = node.isChecked;
      child.nodes && this.updateChildren(child);
    });
  }

  private updateNodeClass() {
    this.node.isPartial = !this.node.isChecked && (this.isAnyChildNodeSelected(this.node) || this.isAnyChildNodePartial(this.node));
  }

  private isAnyChildNodeSelected(node: IItemTreeView): boolean {
    let isSelected = false;

    if (node.nodes && node.nodes.length > 0) {
      isSelected = node.nodes.some(childNode => childNode.isChecked);
    }
  
    return isSelected;
  }

  private isAnyChildNodePartial(node: IItemTreeView): boolean {
    let isSelected = false;

    if (node.nodes && node.nodes.length > 0) {
      isSelected = node.nodes.some(childNode => childNode.isPartial);
    }
  
    return isSelected;
  }
}
